<!--
수량부족오류 처리 컴포넌트
------------------------------------
-->
<template>
    <div style="display: none">
        <!-- 폼 화면 -->
        <div class="uk-flex-top form" uk-modal esc-close="false" bg-close="false">
            <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

                <div class="uk-modal-header">
                    <h4 class="uk-text-center">수량부족 오류처리</h4>
                </div>

                <div class="uk-modal-header">
                    <!-- 상품정보 표시 -->
                    <div class="uk-flex uk-flex-top" >
                        <div class="uk-width-auto uk-text-center">
                            <div class="uk-margin-right">
                                <img
                                    :src="prod.img_url"
                                    width="100"
                                />

                                <!-- 라벨표시 -->
                                <div class="uk-margin-top">
                                    <span v-show="prod.lock_error" class="uk-label uk-label-danger">오류</span>
                                    <span v-show="prod.lock_hold" class="uk-label uk-label-danger">보류중</span>
                                </div>
                            </div>

                        </div>
                        <div class="uk-width-expand uk-grid uk-grid-small">

                            <app-column
                                class="uk-margin-small-bottom uk-width-1-2"
                                header="배송단계"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.state_text }}
                            </app-column>


                            <app-column
                                class="uk-margin-small-bottom uk-width-1-2"
                                header="상품번호"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.id }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom uk-width-1-1"
                                header="상품명"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.name }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom uk-width-1-2"
                                header="색상"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.color }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom uk-width-1-2"
                                header="사이즈"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.size }}
                            </app-column>



                            <app-column
                                class="uk-margin-small-bottom uk-width-1-2"
                                header="보관장소"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.storage }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom uk-width-1-2"
                                header="수량"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.amount }}
                            </app-column>

                        </div>
                    </div>
                </div>

                <div class="uk-modal-body uk-padding-remove uk-flex uk-flex-between uk-child-width-1-2 uk-flex-stretch">

                    <div class="real-arrival">
                        <div class="title">
                            실제도착 수량 : <span class="amount uk-text-primary">{{ error.arrival_amount}}</span>
                        </div>


                        <div class="uk-flex uk-flex-center">
                            <app-input-radio
                                input-size="small"
                                v-model="realArrivalResolveType"
                                :options="realArrivalResolveTypeOptions"
                            > </app-input-radio>
                        </div>
                        <div class="guide" v-show="! realArrivalResolveType">
                            실제도착 상품에 대한 처리방법을 선택하세요
                        </div>

                        <!-- 발송요청 옵션 -->
                        <div class="uk-margin-top" v-show="realArrivalResolveType === 'out'">
                            <app-input-ex
                                type="textarea"
                                :textarea-rows="2"
                                input-size="small"
                                label="발송작업 요청사항"
                                placeholder="작업자가 요청사항을 이해하기 쉽게 작성하세요"

                                v-model="outReqMemo"
                            > </app-input-ex>
                        </div>

                        <!-- 반품 옵션 -->
                        <div class="uk-margin-top" v-show="realArrivalResolveType === 'return'">
                            <app-input-ex
                                class="uk-margin-bottom"
                                type="textarea"
                                label="반품 요청사항"
                                placeholder="작업자에게 전달할 내용을 구체적으로 작성하세요"
                                :textarea-rows="2"
                                v-model="returnReqMemo"
                            ></app-input-ex>

                            <app-input-ex
                                class="uk-margin-bottom"
                                type="select"
                                label="반품사유"
                                :options="this.reasonTypeOptions"
                                v-model="returnReasonType"
                            ></app-input-ex>


                            <app-input-ex
                                class="uk-margin-bottom"
                                type="textarea"
                                label="상세사유"
                                placeholder="상세한 반품사유를 직접 작성하세요"
                                :textarea-rows="2"
                                v-model="returnReasonMemo"
                            ></app-input-ex>
                        </div>
                    </div>


                    <!-- 안내 -->
                    <div class="not-arrival">
                        <div class="title">
                            미도착 수량 : <span class="amount uk-text-danger">{{ prod.amount - error.arrival_amount}}</span>
                        </div>

                        <div class="uk-flex uk-flex-center">
                            <app-input-radio
                                input-size="small"
                                v-model="notArrivalResolveType"
                                :options="notArrivalResolveTypeOptions"
                            > </app-input-radio>
                        </div>
                        <div class="guide" v-show="! notArrivalResolveType">
                            미도착 상품에 대한 처리방법을 선택하세요
                        </div>

                        <!-- 트래킹재입력 옵션 -->
                        <div class="uk-margin-top" v-show="notArrivalResolveType === 'retracking'">
                            <app-input-ex
                                type="text"
                                input-size="small"
                                v-model="retrackingNo"
                                label="새 트래킹번호"

                                placeholder=""
                            > </app-input-ex>
                        </div>
                    </div>

                </div>




                <div class="uk-modal-footer uk-text-right">
                    <!--- 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-default uk-modal-close"
                    >
                        <span uk-icon="icon: close"></span> 취소
                    </button>
                    <button
                        type="button"
                        class="uk-button uk-button-primary"
                        v-on:click="submit()"
                    >
                        <span uk-icon="icon: check"></span>
                        완료
                    </button>
                </div>
            </div>
        </div>


        <!-- 결과 화면 -->
        <div class="uk-flex-top result" uk-modal esc-close="false" bg-close="false">
            <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

                <div class="uk-modal-header">
                    <h4 class="uk-text-center">미도착수량에 대한 분리가 완료되었습니다.</h4>
                </div>
                <div class="uk-modal-body uk-padding-remove">

                    <div class="uk-flex uk-child-width-1-2">
                        <!-- 기존상품 표시 -->
                        <div class="uk-padding-small" style="border-right: 1px solid #eee">
                            <div class="uk-flex uk-margin-top">
                                <div class="uk-width-auto uk-text-center">
                                    <div class="uk-margin-right">
                                        <img
                                            :src="realArrivalProd.img_url"
                                            width="100"
                                        />

                                        <div class="uk-margin-top">
                                            <span class="uk-label uk-label-primary">실제도착상품</span>
                                        </div>
                                    </div>

                                </div>
                                <div class="uk-width-expand">

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="배송단계"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ realArrivalProd.state_text }}
                                    </app-column>


                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="상품번호"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ realArrivalProd.id }}
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="상품명"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        <div class="uk-text-truncate">
                                            {{ realArrivalProd.name }}
                                        </div>
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="보관장소"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ realArrivalProd.storage }}
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="수량"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ realArrivalProd.amount }}
                                    </app-column>

                                </div>
                            </div>

                            <!-- 재고상품 이동버튼 -->
                            <div class="uk-margin-top uk-text-center" v-if="stockProd">
                                <div>
                                    * 기존 상품은 취소처리되고, 재고상품이 새로등록되었습니다.
                                </div>
                                <a class="uk-button uk-button-small uk-button-primary" :href="'/prods/'+stockProd.id">
                                    <i class="material-icons">forward</i>
                                    재고상품으로 이동
                                </a>
                            </div>
                        </div>


                        <!-- 미도착상품 표시 -->
                        <div class="uk-padding-small">
                            <div class="uk-flex uk-margin-top">
                                <div class="uk-width-auto uk-text-center">
                                    <div class="uk-margin-right">
                                        <img
                                            :src="notArrivalProd.img_url"
                                            width="100"
                                        />

                                        <div class="uk-margin-top">
                                            <span class="uk-label uk-label-danger">미도착상품</span>
                                        </div>
                                    </div>


                                </div>
                                <div class="uk-width-expand">

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="배송단계"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ notArrivalProd.state_text }}
                                    </app-column>


                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="상품번호"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ notArrivalProd.id }}
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="상품명"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        <div class="uk-text-truncate">
                                            {{ notArrivalProd.name }}
                                        </div>
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="보관장소"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ notArrivalProd.storage }}
                                    </app-column>

                                    <app-column
                                        class="uk-margin-small-bottom"
                                        header="수량"
                                        header-size="medium"
                                        body-size="medium"
                                        header-align="left"
                                        body-align="left"
                                        horizontal
                                        header-width="80px"
                                    >
                                        {{ notArrivalProd.amount }}
                                    </app-column>

                                </div>
                            </div>

                            <!-- 미도착상품 이동버튼 -->
                            <div class="uk-margin-top uk-text-center">
                                <a class="uk-button uk-button-small uk-button-primary" :href="'/prods/'+notArrivalProd.id">
                                    <i class="material-icons">forward</i>
                                    미도착상품으로 이동
                                </a>
                            </div>



                        </div>

                    </div>


                </div>


                <div class="uk-modal-footer uk-text-center">

                    <!--- 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-default"
                        @click="refreshPage"
                    >
                        <span uk-icon="icon: close"></span> 닫기
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // (object) 상품정보
                prod: {},

                // (object) 오류정보
                error: {},

                // 폼화면 html 엘리먼트
                el_form: null,

                // 결과화면 html 엘리먼트
                el_result: null,

                // (object) 기존 상품
                realArrivalProd: {},

                // (object) 새 미도착 상품
                notArrivalProd: {},

                // (object) 새 재고 상품
                stockProd: {},

                // (string) 실제도착수량 처리방법
                realArrivalResolveType: null,

                // (array) 실제도착수량 처리방법옵션
                realArrivalResolveTypeOptions: [
                    {text: '발송요청', val: 'out'},
                    {text: '반품신청', val: 'return'},
                    {text: '재고보관', val: 'stock'},
                ],

                // (string) 미도착 처리방법
                notArrivalResolveType: null,

                // (array) 미도착 처리방법옵션
                notArrivalResolveTypeOptions: [
                    {text: '재주문', val: 'reorder'},
                    {text: '트래킹재입력', val: 'retracking'},
                    {text: '배송취소', val: 'cancel'},
                ],

                // 발송요청메모
                outReqMemo: null,

                // 반품요청사항
                returnReqMemo: null,

                // 반품사유종류
                returnReasonType: null,

                // 반품사유
                returnReasonMemo: null,

                // 트래킹번호(트래킹재입력)
                retrackingNo: null,

                /**
                 * 반품사유 옵션
                 * (변동가능성이 많이 없어보여서 하드코딩함. 변동가능성이 생기면 추후에 ajax loading 처리함)
                 */
                reasonTypeOptions: [
                    {text: '단순변심', val: '1'},
                    {text: '하자', val: '2'},
                    {text: '오배송', val: '3'},
                    {text: '기타', val: '4'},
                ],
            };
        },
        computed: {
            /**
             * 오배송오류 (상품/색상/사이즈) 인경우,
             * 안내문구 display 여부
             * @return boolean
             */
            displayDescForDiffError() {
                if (! this.error) {
                    return false;
                }

                this.error.type = parseInt(this.error.type)
                return this.error.type === 11
                    || this.error.type === 12
                    || this.error.type === 13;
            },

        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                if (! this.el_form) {
                    this.el_form = $(this.$el).find('.form').get(0);
                }
                if (! this.el_result) {
                    this.el_result = $(this.$el).find('.result').get(0);
                }

                UIkit.modal(this.el_form).show();
            },

            /**
             * 폼
             * @param prod_id 상품ID
             */
            form(prod_id) {

                // 상품정보조회 Promise
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/prods/' + prod_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response.prod);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((prod) => {
                    this.prod = prod;

                    // 오류조회
                    return this.loadError();

                }).then((error) => {
                    this.error = error;

                    // 폼띄우기
                    this.displayForm();

                }).catch((msg) => {
                    alert(msg);
                });

            },

            /**
             * 오류정보 조회 Promise
             * @return Promise
             */
            loadError() {
                // 오류정보조회 Promise
                return new Promise((resolve, reject) => {
                    // 오류상품이 아닌경우
                    if (! this.prod.lock_error) {
                        resolve(null);
                        return;
                    }

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/errors/' + this.prod.lock_error,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response.error);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);



                });
            },

            /**
             * submit
             */
            submit() {
                // 검증
                if (! this.realArrivalResolveType) {
                    alert('실제도착 수량 처리방법을 선택하세요');
                    return;
                }
                if (! this.notArrivalResolveType) {
                    alert('미도착 수량 처리방법을 선택하세요');
                    return;
                }

                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/' + this.prod.id + '/resolve-lack-amount',
                        data: {
                            '_token': this.csrfToken,
                            'real_arrival_resolve_type': this.realArrivalResolveType,
                            'not_arrival_resolve_type': this.notArrivalResolveType,

                            'out_req_memo': this.outReqMemo,

                            'return_req_memo': this.returnReqMemo,
                            'return_reason_type': this.returnReasonType,
                            'return_reason_memo': this.returnReasonMemo,

                            'retracking_no': this.retrackingNo,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                // promise 처리
                load.then((response) => {
                    this.realArrivalProd = response.real_arrival_prod;
                    this.notArrivalProd = response.not_arrival_prod;
                    this.stockProd = response.stock_prod;

                    //UIkit.modal(this.el_form).hide();
                    UIkit.modal(this.el_result).show();
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    .real-arrival, .not-arrival {
        padding: 0.5rem;

        border-right: 1px solid #eee;
        min-height: 180px;

        .title {
            text-align: center;
            font-size: 1.25rem;

            .amount {
                font-size: 1.5rem;
                font-weight: bold;
            }
        }

        .guide {
            text-align: center;
            margin-top: 0.5rem;
            font-size: 1rem;
            color: #999;
        }
    }
    .real-arrival {
        .title {
            //background-color: #f5f8fa;
        }
        .amount {
            color: #1e87f0 !important;
        }
    }
    .not-arrival {
        .title {
            //background-color: #fef4f6;
        }
        .amount {
            color: #f0506e !important;
        }
    }

</style>